/* eslint-disable import/no-named-as-default-member */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/button-has-type */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
import React, {
    useState, useEffect, useCallback, useContext, useRef,
} from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import moment from 'moment';
import AddResourceModal from './Modals/AddResourceModal';
import HeaderContext from '../../../Components/Context/HeaderContext';
import { distributorService } from '../../../service/distributor.service';
import Pagination from '../../../Components/Pagination';
import DeleteResourceModal from './Modals/DeleteResourceModal';
import ResourceListSkeleton from './ResourceListSkeleton';
import DeactivateResourceModal from './Modals/DeactivateResourceModal';
import { GenerateDate, GenerateDateandTime, GenerateDateFormat } from '../../../redux/helper/DateConverter';
import { CDN } from '../../../constants';
import EmptyScreen from '../../../Components/GlobalEmplyPage';
import EmptyScreenwithButton from './EmptyScreenwithButton';

function ResourceManagement() {
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
    } = useContext(HeaderContext);
    const [addResourcePopup, setAddResourcePopup] = useState(false);
    const [addResourceDetails, setAddResourceDetails] = useState({
        resource_category_id: '',
        resource_category_name: '',
        title: '',
        description: '',
        document_type: '',
        document: '',
        status: 1,
    });
    const [resourceList, setResourceList] = useState([]);
    const [threeDotLoader, setThreeDotsLoader] = useState(false);
    const [categoryList, setCategoryList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState('');
    const [alldata, setalldata] = useState({});
    const [searchValue, setsearchValue] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [sortType, setsortType] = useState('published_date+desc');
    const [submitSelected, setsubmitSelected] = useState(false);
    const [editAction, setEditAction] = useState('');
    const [isEdit, setIsEdit] = useState(false);
    const [errorState, setErrorState] = useState({
        resource_category_id: '',
        resource_category_name: '',
        title: '',
        description: '',
        document_type: '',
        document: '',
        status: 1,
    });
    const [deleteModal, setDeleteModal] = useState(false);
    const [activateDeactivateModal, setactivateDeactivateModal] = useState(false);
    const [selectedCategory, setSetselectedCategory] = useState({});
    const [emptyData, setEmptyData] = useState(false);

    const handleFetchCategory = async () => {
        const res = await distributorService.CategoryList();
        if (!res.error && res.data.success_status) {
            setCategoryList(res.data.data.Items);
        } else {
            // handleErrorMessage(details?.data.message);
            // setloading(false);
        }
    };

    useEffect(() => {
        if (searchValue === debouncedSearch) return undefined;
        const timer = setTimeout(() => {
            setLoading(true);
            setDebouncedSearch(searchValue);
            setCurrentPage(1);
        }, 500);
        return () => clearTimeout(timer);
    }, [searchValue, debouncedSearch]);

    const isFirstListChange = useRef(true);
    useEffect(() => {
        if (isFirstListChange.current) {
            isFirstListChange.current = false;
            return;
        }
        setLoading(true);
    }, [currentPage, sortType]);

    const handleFetch = useCallback((() => {
        distributorService.ResourceList(currentPage, debouncedSearch, sortType).then((res) => {
            if (!res.error && res.data.data.success_status) {
                if (res.data.data.Items.length > 0) {
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                }
                setResourceList(res.data.data.Items);
                setCurrentPage(res.data.data.current_page);
                setTotalPage(res.data.data.number_of_pages);
                setalldata(res.data.data);
                setLoading(false);
            } else {
                // handleErrorMessage(details?.data.message);
                // setloading(false);
            }
        });
    }), [currentPage, debouncedSearch, sortType]);

    const validate = () => {
        setsubmitSelected(true);
        let isvalid = true;
        Object.keys(addResourceDetails).forEach((value) => {
            switch (value) {
            case 'resource_category_name':
            case 'resource_category_id':
            case 'title':
            case 'description':
            case 'document':
                if (addResourceDetails[value] === '') {
                    setErrorState((prevState) => ({
                        ...prevState,
                        [value]: `${value} is required`,
                    }));
                    isvalid = false;
                }
                break;
            default: break;
            }
        });
        return isvalid;
    };

    const handleClose = async () => {
        setAddResourceDetails((prevState) => ({
            ...prevState,
            resource_category_id: '',
            resource_category_name: '',
            title: '',
            description: '',
            document_type: '',
            document: '',
            status: 1,
        }));
        setIsEdit(false);
        setEditAction('');
        setsubmitSelected(false);
    };

    const createResoure = async (e) => {
        setsubmitSelected(false);
        if (validate()) {
            setThreeDotsLoader(true);
            const payload = {
                resource_category_id: addResourceDetails.resource_category_id,
                resource_category_name: addResourceDetails.resource_category_name,
                title: addResourceDetails.title,
                description: addResourceDetails.description,
                document_type: addResourceDetails.document_type,
                document: addResourceDetails.document,
                status: 0,
            };
            let res;
            if (isEdit) {
                res = await distributorService.UpdateResource(payload, selectedCategory.resource_id);
            } else {
                res = await distributorService.CreateResource(payload);
            }
            if (!res.error && res.data.success_status) {
                setAddResourcePopup(false);
                setThreeDotsLoader(false);
                setLoading(true);
                handleFetch();
                SetSuccessMessage(res.data.message);
                setTimeout(() => {
                    SetSuccessMessage('');
                }, 2000);
                setSetselectedCategory('');
                setsubmitSelected(false);
                setAddResourceDetails((prevState) => ({
                    ...prevState,
                    resource_category_id: '',
                    resource_category_name: '',
                    title: '',
                    description: '',
                    document_type: '',
                    document: '',
                    status: 1,
                }));
            } else {
                SetErrorMessage(res.data.message);
            }
            setErrorState({
                resource_category_id: '',
                resource_category_name: '',
                title: '',
                description: '',
                document_type: '',
                document: '',
                status: 1,
            });
            handleClose();
            setEditAction('');
        }
    };

    const handleDelete = async () => {
        setThreeDotsLoader(true);
        const res = await distributorService.DeleteResource(selectedCategory.resource_id);
        setDeleteModal(false);
        setThreeDotsLoader(false);
        setLoading(true);
        handleFetch();
        SetSuccessMessage(res.data.message);
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
    };

    const handlePageClick = async (data) => {
        setLoading(true);
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    const handleactivateDeactivate = async () => {
        setThreeDotsLoader(true);
        const body = {
            status: selectedCategory.status === 0 ? 1 : 0,
            published_date: moment.now(),
        };
        const res = await distributorService.UpdateResource(body, selectedCategory.resource_id);
        setactivateDeactivateModal(false);
        setThreeDotsLoader(false);
        setLoading(true);
        handleFetch();
        SetSuccessMessage(res.data.message);
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
        setEditAction('');
    };

    const handleDownload = (item) => {
        window.open(`${CDN}/${item.document}`, '_blank');
        setEditAction('');
    };

    const handleUpdate = (item) => {
        setSetselectedCategory(item);
        setIsEdit(true);
        setAddResourcePopup(true);
    };

    useEffect(() => {
        handleFetch();
        handleFetchCategory();
    }, [handleFetch]);

    return (
        <div className="pb-6 pr-[18px] main-screen">
            <div className="w-full flex justify-between items-center pt-6 pb-[18px] sticky top-[0]">
                <div>
                    <h5 className="text-xs4 font-normal text-[#555259]">Resource Management</h5>
                </div>
                <div className="flex justify-end items-center">
                    <div className="ml-3 relative cursor-pointer sm:mt-0 mt-1">
                        <input
                            type="text"
                            className="w-[180px] h-9 border-2 border-[#E9EDF4] rounded-lg text-sm font-normal text-[#090406] placeholder:font-normal placeholder:text-sm placeholder:text-[#090406] pl-4 pr-14 outline-0"
                            placeholder="Search"
                            onChange={(e) => {
                                setsearchValue(e.target.value);
                            }}
                        />
                        <img src="/images/search-box.svg" alt="icon" className="absolute top-1.5 right-1" />
                    </div>
                    <button
                        type="button"
                        className="ml-2.5 bg-[#555259] border-[#555259] font-semibold text-xs2 h-9 text-[#FFFFFF] border-2 py-1 px-7 rounded-[9px]"
                        data-bs-toggle="modal"
                        data-bs-target="#add-resource-modal"
                        onClick={() => setAddResourcePopup(true)}
                    >
                        Add New
                    </button>
                </div>
            </div>

            {!loading
                ? (
                    <div>
                        {resourceList.length > 0
                        && (
                            <div
                                className="overflow-auto sidebar pb-7 relative z-0 h-customh4"
                                style={{ height: 'calc(100vh - 298px)' }}
                            >
                                <table className="w-full table-auto relative">
                                    <thead className="sticky top-0 left-0 z-10">
                                        <tr className="bg-[#555259] h-10">
                                            <th scope="col" className="py-3 px-7  min-w-[182px] rounded-bl-lg rounded-tl-lg ">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    Title
                                                    <a href="#" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{
                                                                rotate: sortType === 'title+asc' ? 180 : 0,
                                                            }}
                                                            className={`${sortType === 'title' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            onClick={() => {
                                                                setCurrentPage(1);
                                                                if (sortType === 'title+asc') {
                                                                    setsortType('title+desc');
                                                                } else if (sortType === 'title+desc') {
                                                                    setsortType('title+asc');
                                                                } else { setsortType('title+asc'); }
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="py-3 px-7  min-w-[152px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    Category
                                                    <a href="#" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{
                                                                rotate: sortType === 'resource_category_name+asc' ? 180 : 0,
                                                            }}
                                                            className={`${sortType === 'resource_category_name' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            onClick={() => {
                                                                setCurrentPage(1);
                                                                if (sortType === 'resource_category_name+asc') {
                                                                    setsortType('resource_category_name+desc');
                                                                } else if (sortType === 'resource_category_name+desc') {
                                                                    setsortType('resource_category_name+asc');
                                                                } else { setsortType('resource_category_name+asc'); }
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th className="py-3 px-6 min-w-[158px] bg-[#555259] text-left" scope="col">
                                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                    Description
                                                </span>
                                            </th>
                                            <th className="py-3 px-6 min-w-[158px] bg-[#555259] text-left" scope="col">
                                                <span className="text-xs5 font-bold text-[#FFFFFF]">
                                                    Status
                                                </span>
                                            </th>
                                            <th scope="col" className="py-3 px-7  min-w-[185px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                                    Published Date
                                                    <a href="#" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{
                                                                rotate: sortType === 'published_date+asc' ? 180 : 0,
                                                            }}
                                                            className={`${sortType === 'published_date' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            onClick={() => {
                                                                setCurrentPage(1);
                                                                if (sortType === 'published_date+asc') {
                                                                    setsortType('published_date+desc');
                                                                } else if (sortType === 'published_date+desc') {
                                                                    setsortType('published_date+asc');
                                                                } else { setsortType('published_date+asc'); }
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="py-3 px-7  min-w-[152px]">
                                                <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center justify-center">
                                                    Type
                                                    <a href="#" className="pl-[5px]">
                                                        <motion.img
                                                            animate={{
                                                                rotate: sortType === 'document_type+asc' ? 180 : 0,
                                                            }}
                                                            className={`${sortType === 'document_type' ? 'image-rotate' : ''}`}
                                                            src="/images/sort.svg"
                                                            alt="icon"
                                                            onClick={() => {
                                                                setCurrentPage(1);
                                                                if (sortType === 'document_type+asc') {
                                                                    setsortType('document_type+desc');
                                                                } else if (sortType === 'document_type+desc') {
                                                                    setsortType('document_type+asc');
                                                                } else { setsortType('document_type+asc'); }
                                                            }}
                                                        />
                                                    </a>
                                                </span>
                                            </th>
                                            <th scope="col" className="py-3 px-7 min-w-[80px] rounded-tr-lg rounded-br-lg">
                                                {/* <span className="text-xs5 font-bold text-[#FFFFFF] flex items-center">
                                    Status
                                    <a href="#" className="pl-[5px]">
                                        <img src="/images/sort.svg" alt="icon" />
                                    </a>
                                </span> */}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {resourceList.length > 0 && resourceList.map((item, index) => (
                                            <>
                                                <tr className="bg-[#FDFDFE] border-b border-[#DFEAF7]">
                                                    <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                                        {item.title}
                                                    </td>
                                                    <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                                        {item.resource_category_name}
                                                    </td>
                                                    <td className="text-sm font-normal text-[#090406] pt-2.5 px-7 more-lines">
                                                        {item.description}
                                                    </td>
                                                    {item.status === 1 ? (
                                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                                            Active
                                                        </td>
                                                    ) : (
                                                        <td className="text-sm font-normal text-[#090406] py-2.5 px-7">
                                                            Inactive
                                                        </td>
                                                    )}
                                                    {item.published_date === null
                                                        ? (
                                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                                -
                                                            </td>
                                                        )
                                                        : (
                                                            <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                                {GenerateDateandTime(item.published_date / 1000)}
                                                            </td>
                                                        )}

                                                    <td className="text-sm font-normal text-[#090406] py-2.5 px-7 text-center">
                                                        {item.document_type}
                                                    </td>
                                                    <td className="text-xs3 font-normal text-[#0D1B2A] px-5 py-3 dropstart relative flex justify-center">
                                                        <button
                                                            href="#"
                                                            class="flex justify-center items-center"
                                                            dropdown-toggle
                                                            id={`actionButton${index}`}
                                                            data-bs-toggle="dropdown"
                                                            aria-expanded="false"
                                                            onClick={() => { if (index === editAction) setEditAction(''); else setEditAction(index); }}
                                                        >
                                                            <img src="/images/three-dots.html.png" alt="icon" />
                                                        </button>
                                                        <ul className={`dropdown-menu ${editAction === index ? 'show' : 'hidden'} z-50 absolute right-[60px] bg-[#FFFFFF] w-fit rounded-lg shadow-s11 p-3`} aria-labelledby="actionButton">
                                                            <button
                                                                className="inline-block dropdown-item w-full"
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#update-category"
                                                                onClick={() => handleUpdate(item)}
                                                            >
                                                                <li className="text-sm font-normal text-[#000000] py-1 px-2 cursor-pointer">
                                                                    Edit
                                                                </li>
                                                            </button>
                                                            <button onClick={() => { setactivateDeactivateModal(true); setSetselectedCategory(item); }} className="inline-block dropdown-item w-full" data-bs-toggle="modal" data-bs-target="#activateresourceModal">
                                                                <li className="text-sm font-normal text-[#000000] py-1 px-2 cursor-pointer">
                                                                    {item.status === 1 ? 'Deactivate' : 'Activate'}
                                                                </li>
                                                            </button>
                                                            <button onClick={() => { setDeleteModal(true); setSetselectedCategory(item); }} className="inline-block dropdown-item w-full">
                                                                <li className="text-sm font-normal text-[#000000] py-1 px-2 cursor-pointer">
                                                                    Delete
                                                                </li>
                                                            </button>
                                                            <button onClick={() => handleDownload(item)} className="inline-block dropdown-item w-full">
                                                                <li className="text-sm font-normal text-[#000000] py-1 px-2 cursor-pointer">
                                                                    Download
                                                                </li>
                                                            </button>
                                                        </ul>
                                                    </td>
                                                </tr>
                                                <tr className="h-1" />
                                            </>

                                        ))}

                                    </tbody>
                                </table>
                            </div>
                        )}
                        { resourceList.length > 0 && (
                            <Pagination
                                handlePageClick={handlePageClick}
                                List={alldata}
                                currentPage={currentPage}
                                totalPage={totalPage}
                            />
                        )}
                    </div>
                )
                : <ResourceListSkeleton />}

            {resourceList.length === 0
                && (
                    <EmptyScreenwithButton
                        searchValue={searchValue}
                        addResourcePopup={addResourcePopup}
                        setAddResourcePopup={setAddResourcePopup}
                    />
                ) }

            {addResourcePopup && (
                <AddResourceModal
                    addResourcePopup={addResourcePopup}
                    setAddResourcePopup={setAddResourcePopup}
                    addResourceDetails={addResourceDetails}
                    setAddResourceDetails={setAddResourceDetails}
                    categoryList={categoryList}
                    setCategoryList={setCategoryList}
                    createResoure={createResoure}
                    submitSelected={submitSelected}
                    setsubmitSelected={setsubmitSelected}
                    threeDotLoader={threeDotLoader}
                    setThreeDotsLoader={setThreeDotsLoader}
                    isEdit={isEdit}
                    setIsEdit={setIsEdit}
                    selectedCategory={selectedCategory}
                    setSetselectedCategory={setSetselectedCategory}
                    handleClose={handleClose}
                />
            )}
            {deleteModal && (
                <DeleteResourceModal
                    deleteModal={deleteModal}
                    setDeleteModal={setDeleteModal}
                    handleDelete={handleDelete}
                    selectedCategory={selectedCategory}
                    threeDotLoader={threeDotLoader}
                    setThreeDotsLoader={setThreeDotsLoader}
                />
            )}
            {activateDeactivateModal && (
                <DeactivateResourceModal
                    activateDeactivateModal={activateDeactivateModal}
                    setactivateDeactivateModal={setactivateDeactivateModal}
                    selectedCategory={selectedCategory}
                    handleactivateDeactivate={handleactivateDeactivate}
                    threeDotLoader={threeDotLoader}
                    setThreeDotsLoader={setThreeDotsLoader}
                />
            )}

        </div>
    );
}

export default ResourceManagement;
